export default "__VITE_ASSET__51207091__"